import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navigation = () => {
  const [hidden, setHidden] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > 100) {
        setHidden(true);
      } else {
        setHidden(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {isHome && (
        <div className={`corner-title ${hidden ? 'hidden' : ''}`}>
          BOSU DEVINENI
        </div>
      )}
      
      <div className="corner-menu">
        <a href="#work" className="menu-item">Work</a>
        <a href="#about" className="menu-item">About</a>
        <a href="#contact" className="menu-item">Contact</a>
        
        {/* Resume button - always visible */}
        <a 
          href="/assets/resume.pdf" 
          download="Bosu_Devineni_Resume.pdf"
          className="menu-item menu-item-resume"
        >
          Resume ↓
        </a>
      </div>
    </>
  );
};

export default Navigation;